import { Component, ElementRef, OnInit } from '@angular/core';
import { InceptionService } from '@dch/ng-common';

@Component({
  selector: 'my-bill-evolution-chart-skeleton',
  templateUrl: './my-bill-evolution-chart-skeleton.component.html',
  standalone: false,
})
export class MyBillEvolutionChartSkeletonComponent implements OnInit {
  constructor(
    private elementRef: ElementRef,
    private inceptionService: InceptionService
  ) {}

  ngOnInit() {
    setTimeout(() => this.inceptionService.cssLoad(this.elementRef));
  }
}
